<app-group-sharing-lobby [premierDetails]="premiere" *ngIf="showGSLobby"></app-group-sharing-lobby>
<app-red-carpet [premierDetails]="premiere" *ngIf="showRedCarpert"></app-red-carpet>
<app-theater *ngIf="showThetre"></app-theater>
<app-group-sharing-lobby-qa *ngIf="showGSQALobby" [eventId]="eventId"></app-group-sharing-lobby-qa>
<div class="group-share-container" *ngIf="(showThetre || showRedCarpert) && !hideGroupSharing">
    <app-group-share (isGroupShareActive)="isGroupShareActive($event)" [eventId]="eventId"></app-group-share>
</div>